import { Button, FileUpload, TextInput } from "../../components/ui";

export default function AgentDocumentUploadForm({
  file,
  description,
  accept,
  busy,
  onFileChange,
  onDescriptionChange,
  onSubmit,
  onCancel,
  showIntro = true,
}: {
  file: File | null;
  description: string;
  accept: string;
  busy: boolean;
  onFileChange: (file: File | null) => void;
  onDescriptionChange: (value: string) => void;
  onSubmit: () => void;
  onCancel?: () => void;
  showIntro?: boolean;
}) {
  return (
    <form
      className="company-document-upload"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      {showIntro && (
        <div className="company-document-upload__intro">
          <strong>Upload a document</strong>
          <span>Add verified source material without launching a run.</span>
        </div>
      )}
      <FileUpload
        label="File"
        helperText="PDF, presentation, document, data, workbook, or image."
        accept={accept}
        disabled={busy}
        onFilesChange={(files) => onFileChange(files[0] ?? null)}
      />
      <label>
        <span>Description · optional</span>
        <TextInput
          value={description}
          disabled={busy}
          placeholder={file?.name ?? "Defaults to the filename"}
          onChange={(event) => onDescriptionChange(event.target.value)}
        />
      </label>
      <div className="company-document-upload__actions">
        <div className="company-document-upload__action-buttons">
          {onCancel && (
            <Button
              type="button"
              tone="quiet"
              disabled={busy}
              onClick={onCancel}
            >
              Cancel
            </Button>
          )}
          <Button type="submit" tone="primary" disabled={busy || file === null}>
            {busy ? "Uploading…" : "Upload"}
          </Button>
        </div>
      </div>
    </form>
  );
}
